export const INTERNAL_JSD_LAND = 'jsdland' as const;
export const INTERNAL_JSD_EXPAND = 'jsdjsw' as const;

export type Audience = typeof INTERNAL_JSD_LAND | typeof INTERNAL_JSD_EXPAND | undefined;

export type State = {
	readonly completedTasks: {
		[key: string]: boolean;
	};
	readonly isDismissed: boolean;
	readonly isOpen: boolean;
	readonly openTask: string | undefined;
	readonly isLoadingAppState: boolean;
	readonly otherProject:
		| undefined
		| {
				readonly name: string;
				readonly key: string;
				readonly isNextGen: boolean;
		  };
	readonly demoProject:
		| undefined
		| {
				readonly id?: number;
				readonly key?: string;
				readonly name: string;
		  };
	readonly remoteStateUpdatingCount?: number;
	readonly isRemoteStateUpdated?: boolean;
	readonly version: number;
	readonly audience: Audience;
};
